module.exports = __webpack_public_path__ + "static/media/change_password_success.edfbbb4d.png";